import {connect} from '../../../../redux/utils'
import {bindActionCreators} from 'redux'
import {
    getCounters,
    getEntirelyAssignedProjectCounter,
    getEntirelyAssignedTasksCounter,
    getPanelUserFirstName,
    getSearch,
    isSearchOpen,
    getTab,
    selectCustomerEntities,
    selectProjectEntities,
    selectTaskEntities,
    isShowArchivedEntities,
} from '../selectors'
import {
    changeAssignmentPanelTab,
    revokeAllTypeAction,
    revokeEntitiesAction,
    setIsShowArchiveEntities,
    setSearchString,
    setSearchOpen
} from '../actions'
import ManagementAssignmentPanelTabContent from '../../hierarchyAssignmentsPanelTab/components/ManagementAssignmentPanelTabContent'
import {openEditor} from '../../managementAssignmentsEditor/actions'
import {isWASEnabled} from '../../../../features/selectors'

export default connect(
    state => ({
        userFirstName: getPanelUserFirstName(state),
        counters: getCounters(state),

        searchString: getSearch(state),
        searchOpen: isSearchOpen(state),

        entirelyAssignedTasksCounter: getEntirelyAssignedTasksCounter(state),
        entirelyAssignedProjectsCounter: getEntirelyAssignedProjectCounter(state),

        customerEntities: selectCustomerEntities(state),
        projectEntities: selectProjectEntities(state),
        taskEntities: selectTaskEntities(state),

        isShowArchivedEntities: isShowArchivedEntities(state),

        openTab: getTab(state),

        isWASEnabled: isWASEnabled(state),
    }),
    dispatch => ({
        onSearchChanged: bindActionCreators(setSearchString, dispatch),
        onSearchToggled: bindActionCreators(setSearchOpen, dispatch),

        onEntityRevoked: bindActionCreators(revokeEntitiesAction, dispatch),
        onAllRevoked: bindActionCreators(revokeAllTypeAction, dispatch),

        setIsShowArchiveEntities: bindActionCreators(setIsShowArchiveEntities, dispatch),
        onEditButtonClick: bindActionCreators(openEditor, dispatch),
    })
)(ManagementAssignmentPanelTabContent)


// WEBPACK FOOTER //
// ./web/js/administration/userManagement/editManagementAssignmentsPanel/components/TabContent.js